import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { SapDocumentTypeService } from '../proxy/controlling/controllers/sap-document-type.service';
import { ProfitCenterService } from '../proxy/controlling/controllers/profit-center.service';
import { AccountService } from '../proxy/controlling/controllers/account.service';
import { SapPostingKeyService } from '../proxy/controlling/controllers/sap-posting-key.service';
import { TaxService } from '../proxy/controlling/controllers/tax.service';
FieldBuilder.setNamespace('Controlling');

export const SAPFIPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('documentTypeId', 'Entity.SapDocumentType', SapDocumentTypeService)
    .displayFromNested('sapDocumentType.name')
    .sortBy('sapDocumentType.name')
    .build(),
  FieldBuilder.checkbox('hasProfitCenter', 'Entity.SapFiParameter.HasProfitCenter')
    .build(),
  FieldBuilder.foreignKey('profitCenterId', 'Entity.ProfitCenter', ProfitCenterService)
    .displayFromNested('profitCenter.sapCode')
    .sortBy('profitCenter.sapCode')
    .build(),
  FieldBuilder.checkbox('hasAssignment', 'Entity.SapFiParameter.HasAssignment')
    .build(),
  FieldBuilder.foreignKey('accountId', 'Entity.Account', AccountService)
    .displayFromNested('account.name')
    .sortBy('account.name')
    .build(),
  FieldBuilder.foreignKey('positivePostingKeyId', 'Entity.SapFiParameter.PositivePostingKey', SapPostingKeyService)
    .displayFromNested('positiveSapPostingKey.name')
    .sortBy('positiveSapPostingKey.name')
    .build(),
  FieldBuilder.foreignKey('negativePostingKeyId', 'Entity.SapFiParameter.NegativePostingKey', SapPostingKeyService)
    .displayFromNested('negativeSapPostingKey.name')
    .sortBy('negativeSapPostingKey.name')
    .build(),
  FieldBuilder.foreignKey('taxId', 'Entity.Tax', TaxService)
    .displayFromNested('tax.name')
    .sortBy('tax.name')
    .build(),
  FieldBuilder.checkbox('hasFuelReception', 'Entity.SapFiParameter.HasFuelReception')
    .build(),
  FieldBuilder.checkbox('hasCertificateDeduction', 'Entity.SapFiParameter.HasCertificateDeduction')
    .build(),
  FieldBuilder.checkbox('isPositiveAmount', 'Entity.SapFiParameter.IsPositiveAmount')
    .build(),
  FieldBuilder.text('sglIndicator', 'Entity.SapFiParameter.SglIndicator')
    .build(),
];

export const SAPFIPARAMETER_CONFIG = {
  entityName: 'SapFiParameter',
  localizationKey: 'Controlling::Entity.SapFiParameter',
  fields: SAPFIPARAMETER_FIELDS,
  permission: 'ControllingSap.SapFiParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
